import { css } from 'emotion';

import { colors, fonts } from '../../styles';

export const headCell = {
  root: {
    border: 'none',
    fontSize: fonts.size.small,
    color: colors.gray.dark,
    padding: '20px 10px 10px',
    letterSpacing: 'normal',

    '&:first-child': {
      paddingLeft: 20,
    },

    '&:last-child': {
      paddingRight: 20,
    },
  },
  head: {
    lineHeight: '19px',
  },
};

export const headRow = {
  head: {
    height: 'auto',
  },
};

export const hintStyles = {
  tooltip: {
    maxWidth: 200,
  },
};

export const tooltip = css`
  margin-left: 10px;
  display: inline-flex;
  vertical-align: middle;
`;
